import lazyLoadOnRender from '../../lazy/loadOnRender';

const RealtimeClient = () => import(/* webpackChunkName: "4-feat-realtime" */ './RealtimeClient');

export default lazyLoadOnRender({ loader: RealtimeClient });
